import React, {Component} from 'react'
import PropTypes from 'prop-types'
import humanizeTime from '../../../../helpers/time/humanizeTime'
import {ObjectInspector} from 'react-inspector'

class OrderHistoriesTable extends Component {
    render() {
        const {histories} = this.props
        const historiesReverse = histories.reverse()

        return (
            <table className='OrderHistoriesTable table table-striped'>
                <thead className='thead-light'>
                <tr>
                    <th>Date</th>
                    <th>IP</th>
                    <th>Action</th>
                </tr>
                </thead>

                <tbody>
                {
                    historiesReverse.map((history, index) => {
                        const {created_at, IP, action, meta} = history
                        const objMeta = Object.assign({}, meta)

                        return (
                            <tr key={`orderHistory_${index}`}>
                                <td>{humanizeTime(created_at)}</td>
                                <td>{IP}</td>
                                <td>
                                    <div className='mb-2'>
                                        {action}
                                    </div>

                                    {
                                        Object.keys(objMeta).length > 0 &&
                                        <ObjectInspector data={meta}/>
                                    }
                                </td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </table>
        )
    }
}

OrderHistoriesTable.propTypes = {
    histories: PropTypes.array.isRequired,
}

export default OrderHistoriesTable
